<div class="container">
  <div class="style-none">
    <nav aria-label="Breadcrumb">
      <ol class="em-c-breadcrumbs mb-0">
        <li class="em-c-breadcrumbs__item">
          <a href="" class="em-c-breadcrumbs__link" (click)="GoBackToEditSample(); $event.preventDefault()">Edit
            sample</a>
        </li>
        <li class="em-c-breadcrumbs__item ">
          <span class="em-c-breadcrumbs__link" aria-current="page">
            Final sample inputs
          </span>
        </li>
      </ol>
    </nav>
  </div>
  <div class="table-background">
    <mat-tab-group mat-stretch-tabs class="parent-tab-group" [selectedIndex]="selectedTab"
      class="custom-header-width vertical-tab-style" #tabChange mat-align-tabs="start"
      [(selectedIndex)]="selectedIndex">
      <mat-tab label="Final Sample Inputs">
        <div>
          <form [formGroup]="finalSampleInput">
            <div class="form-row">
              <div class="rfpod-data">
                <article class="em-c-card" aria-labelledby="cardTitle-:r3v:" aria-describedby="cardDescription-:r3v:"
                  tabindex="0">
                  <span class="em-c-card__flag em-c-card__flag-blue" role="status" aria-label="RFPOD Data" tabindex="0">
                    RFPOD Data
                  </span>
                  <div class="em-c-card__body">
                    <div class="em-c-media-block em-c-media-block--small" aria-labelledby="cardTitle-:r3v:"
                      aria-describedby="cardDescription-:r3v:" role="figure" tabindex="0">
                      <div class="em-c-media-block__body">
                        <!-- FlowingTopDepth -->
                        <div id="flowingTopDepth-field"
                          class="em-c-field em-c-field--small em-u-max-width-15 min-height-62">
                          <label for="flowingTopDepth" class="em-c-field__label">Flowing Top Depth</label>
                          <div class="em-c-field__body">
                            <input matInput class="em-c-input em-js-input em-u-max-width-15" type="number"
                              [readonly]="roleId === roleIds.techResource" formControlName="flowingTopDepth"
                              id="flowingTopDepth" appBlockInvalidChars />
                          </div>
                        </div>
                        <!-- FlowingBottomDepth -->
                        <div id="flowingBottomDepth-field"
                          class="em-c-field em-c-field--small em-u-max-width-15  min-height-62">
                          <label for="flowingBottomDepth" class="em-c-field__label">Flowing Bottom Depth</label>
                          <div class="em-c-field__body">
                            <input matInput class="em-c-input em-js-input em-u-max-width-15" type="number"
                              [readonly]="roleId === roleIds.techResource" formControlName="flowingBottomDepth"
                              id="flowingBottomDepth" appBlockInvalidChars />
                          </div>
                        </div>
                        <!-- DepthMeasurementType -->
                        <div id="depthMeasurementType-field"
                          class="em-c-field em-c-field--small em-u-max-width-15  min-height-62">
                          <label for="depthMeasurementType" class="em-c-field__label">Depth Measurement Type</label>
                          <div class="em-c-field__body">
                            <select class="em-c-select em-u-max-width-11" formControlName="depthMeasurementType"
                              id="depthMeasurementType" name="depthMeasurementType">
                              <option [ngValue]="null">Select type</option>
                              @for (type of depthMeasurementTypes; track $index) {
                              <option [ngValue]="type.depthMeasurementTypeId">
                                {{ type.depthMeasurementType }}
                              </option>
                              }
                            </select>
                          </div>
                        </div>
                        <!-- UpperPerforationDepth -->
                        <div id="upperPerforationDepth-field"
                          class="em-c-field em-c-field--small em-u-max-width-15  min-height-62 upperdepth">
                          <label for="upperPerforationDepth" class="em-c-field__label">Upper Perforation Depth</label>
                          <div class="em-c-field__body">
                            <input class="em-c-input em-js-input em-u-max-width-15" matInput type="number"
                              [readonly]="roleId === roleIds.techResource" formControlName="upperPerforationDepth"
                              id="upperPerforationDepth" appBlockInvalidChars />
                          </div>
                        </div>
                        <!-- LowerPerforationDepth -->
                        <div id="lowerPerforationDepth-field"
                          class="em-c-field em-c-field--small em-u-max-width-15  min-height-62">
                          <label for="lowerPerforationDepth" class="em-c-field__label">Lower Perforation Depth</label>
                          <div class="em-c-field__body">
                            <input matInput class="em-c-input em-js-input em-u-max-width-15" type="number"
                              [readonly]="roleId === roleIds.techResource" formControlName="lowerPerforationDepth"
                              id="lowerPerforationDepth" />
                          </div>
                        </div>
                        <!-- VolumeTransferred -->
                        <div id="volumeTransferred-field"
                          class="em-c-field em-c-field--small em-u-max-width-15  min-height-62">
                          <label for="volumeTransferred" class="em-c-field__label">Volume Transferred</label>
                          <div class="em-c-field__body">
                            <input class="em-c-input em-js-input em-u-max-width-15" matInput type="number"
                              [readonly]="roleId === roleIds.techResource" formControlName="volumeTransferred"
                              id="volumeTransferred" appBlockInvalidChars />
                          </div>
                        </div>
                        <!-- SampleVolume -->
                        <div id="sampleVolume-field" class="em-c-field em-c-field--small em-u-max-width-15">
                          <label for="sampleVolume" class="em-c-field__label">Sample Volume</label>
                          <div class="em-c-field__body">
                            <input matInput class="em-c-input em-js-input em-u-max-width-15" type="number"
                              [readonly]="roleId === roleIds.techResource" formControlName="sampleVolume"
                              id="sampleVolume" appBlockInvalidChars />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
              <div class="rfpod-data">
                <article class="em-c-card" aria-labelledby="cardTitle-:r3v:" aria-describedby="cardDescription-:r3v:"
                  tabindex="0">
                  <span class="em-c-card__flag em-c-card__flag-blue" role="status" aria-label="Final Report Inputs"
                    tabindex="0">
                    Final Report Inputs
                  </span>
                  <div class="em-c-card__body">
                    <div class="em-c-media-block em-c-media-block--small" aria-labelledby="cardTitle-:r3v:"
                      aria-describedby="cardDescription-:r3v:" role="figure" tabindex="0">
                      <div class="em-c-media-block__body">
                        <!-- ReservoirFluid -->
                        <div id="reservoirFluid-field"
                          class="em-c-field em-c-field--small em-u-max-width-15 min-height-62">
                          <label for="reservoirFluid" class="em-c-field__label">Reservoir Fluid</label>
                          <div class="em-c-field__body">
                            <input matInput class="em-c-input em-js-input em-u-max-width-15" type="text"
                              [readonly]="roleId === roleIds.techResource" formControlName="reservoirFluid"
                              id="reservoirFluid" />
                          </div>
                        </div>
                        <!-- ReservoirAge -->
                        <div id="reservoirAge-field"
                          class="em-c-field em-c-field--small em-u-max-width-15  min-height-62">
                          <label for="reservoirAge" class="em-c-field__label">Reservoir Age</label>
                          <div class="em-c-field__body">
                            <input matInput class="em-c-input em-js-input em-u-max-width-15" type="text"
                              [readonly]="roleId === roleIds.techResource" formControlName="reservoirAge"
                              id="reservoirAge" />
                          </div>
                        </div>
                        <!-- Installation -->
                        <div id="installation-field"
                          class="em-c-field em-c-field--small em-u-max-width-15  min-height-62">
                          <label for="installation" class="em-c-field__label">Sampling Depth</label>
                          <div class="em-c-field__body">
                            <input class="em-c-input em-js-input em-u-max-width-15" matInput type="text"
                              [readonly]="roleId === roleIds.techResource" formControlName="samplingDepth"
                              id="samplingDepth" appBlockInvalidChars />
                          </div>
                        </div>
                        <!-- TestType -->
                        <div id="testType-field" class="em-c-field em-c-field--small em-u-max-width-15  min-height-62">
                          <label for="testType" class="em-c-field__label">Test Type</label>
                          <div class="em-c-field__body">
                            <input matInput class="em-c-input em-js-input em-u-max-width-15" type="text"
                              [readonly]="roleId === roleIds.techResource" formControlName="testType" id="testType" />
                          </div>
                        </div>
                        <!-- DateSampled -->
                        <div class="em-c-field em-c-field--small em-c-field-datepicker">
                          <label for="dateSampled" class="em-c-field__label">Date Sampled</label>
                          <div class="em-c-field__body">
                            <mat-form-field appearance="outline" class="datepicker">
                              <input class="em-c-input em-js-input " formControlName="dateSampled" id="dateSampled"
                                name="dateSampled" [matDatepicker]="picker" matInput placeholder="MM/DD/YYYY"
                                readonly />
                              <mat-datepicker-toggle [disabled]="roleId === roleIds.techResource" matSuffix
                                [for]="picker"></mat-datepicker-toggle>
                              <mat-datepicker #picker></mat-datepicker>
                            </mat-form-field>
                          </div>
                        </div>
                        <!-- SamplingCompany -->
                        <div id="samplingCompany-field" class="em-c-field em-c-field--small em-u-max-width-15">
                          <label for="samplingCompany" class="em-c-field__label">Sampling Company</label>
                          <div class="em-c-field__body">
                            <input matInput class="em-c-input em-js-input em-u-max-width-15" type="text"
                              [readonly]="roleId === roleIds.techResource" formControlName="samplingCompany"
                              id="samplingCompany" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </form>
        </div>
        <hr />

        <div class="button-div">
          <div class="em-c-btn-group">
            @if (ShowInputSave()) {
            <button class="em-c-btn em-c-btn--primary em-c-btn--small"
              [class.readonly-select]="roleId === roleIds.techResource"
              (click)="SaveFinalInputsData('save')">Save</button>
            }
            @if (ShowInputUpdate()) {
            <button class="em-c-btn em-c-btn--primary em-c-btn--small"
              [class.readonly-select]="roleId === roleIds.techResource"
              (click)="SaveFinalInputsData('update')">Update</button>
            }
            <button class="em-c-btn em-c-btn--small em-js-modal-dismiss" (click)="OnCancel()">Cancel</button>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Sampling Information">
        <!-- Opening Table -->
        <div class='em-dc-table-object em-c-table--striped em-dc-bottom_margin_zero em-dc-table_striped" '>
          <div class="em-c-table-object__body">
            <div class="em-c-table-object__body-inner em-dc-table_container">
              <table mat-table [dataSource]="dataSource" class="em-c-table em-dc-table em-u-margin-bottom-none"
                role="table" editable>

                <ng-container matColumnDef="isRecombine">
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">
                    Select
                  </th>
                  <td mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" [checked]="row?.isRecombine === true"
                      (change)="row.isRecombine = ValidateSelectedCount($event) ? $event.checked : false;"
                      [disabled]="roleId === roleIds.techResource">
                    </mat-checkbox>
                  </td>
                </ng-container>
                @for (col of headers; track $index) {
                <ng-container [matColumnDef]="col">
                  @if(col==='rowNo'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Row No</th>
                  }
                  @if(col==='bottleNumber'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Bottle</th>
                  }
                  @if(col==='sampleDepthPoint'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Sample Depth Point</th>
                  }
                  @if(col==='sampleNumber'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Sample</th>
                  }
                  @if(col==='reservoir'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Reservoir</th>
                  }
                  @if(col==='bottleType'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Bottle Type</th>
                  }
                  @if(col==='sampleVolume'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Sample Volume</th>
                  }
                  @if(col==='bottleSN'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Bottle S/N</th>
                  }
                  @if(col==='temperature'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Opening Temp. (°F)</th>
                  }
                  @if(col==='pressure'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Opening Press. (psia)</th>
                  }
                  @if(col==='closingTemperature'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Closing Temp. (°F)</th>
                  }
                  @if(col==='closingPressure'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Closing Press. (psia)</th>
                  }
                  @if(col==='sampleType'){
                  <th mat-header-cell *matHeaderCellDef class="header-align-center">Sample Type</th>
                  }
                  <td mat-cell *matCellDef="let element; let index = index">
                    <div class="em-c-field em-c-field--small em-u-max-width-15">
                      <div class="em-c-field__body">
                        <input id="{{col+'_'+index}}"
                          [type]="col === 'closingTemperature' || col === 'closingPressure' ? 'number' : 'text'"
                          (keydown)="PreventInvalidNumberInput($event, col)"
                          class="em-c-input em-js-input em-u-max-width-15" matInput [(ngModel)]="element[col]"
                          [readonly]="col === 'sampleNumber' || col === 'bottleNumber' || col === 'temperature' || col === 'pressure' || roleId === roleIds.techResource" />
                      </div>
                    </div>
                  </td>
                </ng-container>
                }
                <thead>
                  <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                </thead>
                <tr mat-row *matRowDef="let record; columns:displayColumns;" class="table-row"></tr>
              </table>
            </div>
          </div>
        </div>
        <hr>
        <div class="button-div">
          <div class="em-c-btn-group">
            <button class="em-c-btn em-c-btn--primary em-c-btn--small em-c-btn__text"
              [class.readonly-select]="roleId === roleIds.techResource"
              (click)="SaveSamplingInformation()">Save</button>
            <button class="em-c-btn em-c-btn--small em-js-modal-dismiss em-c-btn__text"
              (click)="OnCancel()">Cancel</button>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Front Page">
        <div>
          <form [formGroup]="frontPageForm">
            <div class="form-row">
              <div class="frontPageForm-data">
                <div class="em-c-card">
                  <div class="em-c-media-block__body" [formGroup]="frontPageForm">
                    <div class="row">
                      <img [src]="exxonmobilBanner" alt="Exxonmobil Banner" class="exxonmobilBanner">
                      <img [src]="energyBanner" alt="Energy Banner" class="energyBanner">
                      <h3>Reservoir Fluid PVT Study</h3>
                      <h3>Wellbore</h3>
                      <h6>{{wellName}}</h6>
                      <div class="sampleProduction">
                        <h6>{{reportSampleType}} Sample</h6> <label for="productionInterval"
                          class="em-c-field__label">@if(ShowDSTForm()){
                          Perforation Interval:
                          }@else if(ShowSeparatorForm()){
                          Production Interval:
                          }
                        </label> <input matInput class="em-c-input em-js-input" type="text"
                          placeholder="Production Interval" formControlName="productionInterval"
                          [readonly]="roleId === roleIds.techResource" />
                      </div>

                      <div class="em-c-field em-c-field--small ">
                        <label for="reportDate" class="em-c-field__label">Report date</label>
                        <div class="em-c-field__body">
                          <mat-form-field appearance="outline" class="datepicker">
                            <input class="em-c-input em-js-input " formControlName="reportDate" id="reportDate"
                              name="reportDate" [matDatepicker]="reportDatePicker" matInput placeholder="MM/DD/YYYY"
                              readonly />
                            <mat-datepicker-toggle matSuffix [for]="reportDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #reportDatePicker></mat-datepicker>
                          </mat-form-field>
                        </div>
                      </div>
                      <h3>EMHC - The Integrated Fluids Lab</h3>
                      <!-- Lab Crew -->
                      <div id="labCrew-field"
                        class="em-c-field em-c-field--small em-u-max-width-15 min-height-62 labCrew"
                        formArrayName="labCrew">

                        <div class="lab-crew-header">
                          <label class="em-c-field__label" for="labCrew_0">Lab Crew</label>
                        </div>

                        <div class="em-c-field__body">
                          <!-- Dynamic rows -->
                          @for (ctrl of LabCrewArray.controls; let i = $index; track ctrl) {
                          <div class="lab-crew-row">

                            <input matInput class="em-c-input em-js-input" type="text" [attr.id]="'labCrew_' + i"
                              [formControlName]="i" placeholder="Crew member"
                              [readonly]="roleId === roleIds.techResource" />

                            <svg class="em-c-icon em-c-icon--small em-c-btn__icon delete-icon"
                              (click)="roleId !== roleIds.techResource && ConfirmRemoveCrew(i)"
                              (keydown.enter)="roleId !== roleIds.techResource && ConfirmRemoveCrew(i)"
                              [class.disabled-icon]="roleId === roleIds.techResource" tabindex="0" title="Delete">
                              <use xlink:href="images/16/em-icons.svg#trashcan"></use>
                            </svg>
                          </div>
                          }
                        </div>
                        <button type="button" class="em-c-btn em-c-btn--small em-c-btn--primary" (click)="AddLabCrew()"
                          [disabled]="roleId === roleIds.techResource">
                          + Add
                        </button>
                      </div>

                      <img [src]="officeImage" alt="Office Image Banner" class="officeImageBanner">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <hr />

        <div class="button-div">
          <div class="em-c-btn-group">
            @if (ShowReportDetailsSave()) {
            <button class="em-c-btn em-c-btn--primary em-c-btn--small"
              [class.readonly-select]="roleId === roleIds.techResource"
              (click)="SaveFinalReportDetailsData('save')">Save</button>
            }
            @if (ShowReportDetailsUpdate()) {
            <button class="em-c-btn em-c-btn--primary em-c-btn--small"
              [class.readonly-select]="roleId === roleIds.techResource"
              (click)="SaveFinalReportDetailsData('update')">Update</button>
            }
            <button class="em-c-btn em-c-btn--small em-js-modal-dismiss" (click)="OnCancel()">Cancel</button>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Cover Letter">
        <div>
          <form [formGroup]="coverLetterForm">
            <div class="form-row">
              <div class="coverLetterForm-data">
                <div class="em-c-card">
                  <div class="em-c-media-block__body" [formGroup]="coverLetterForm">
                    <div class="row">
                      <div class="topRow">
                        <span class="em-c-field__label">Report from address: </span>
                        <span class="em-c-field__label">{{ frontPageForm.get('productionInterval')?.value}}</span>
                      </div>
                      <div class="row">
                        <div class="addressRow">
                          Address Line 1: <input matInput class="em-c-input em-js-input" type="text"
                            placeholder="Top Address Line 1" formControlName="fromAddress1"
                            [readonly]="roleId === roleIds.techResource" />
                          Address Line 2:<input matInput class="em-c-input em-js-input" type="text"
                            placeholder="Top Address Line 2" formControlName="fromAddress2"
                            [readonly]="roleId === roleIds.techResource" />
                        </div>
                        <div class="addressRow">
                          Address Line 3:<input matInput class="em-c-input em-js-input" type="text"
                            placeholder="Top Address Line 3" formControlName="fromAddress3"
                            [readonly]="roleId === roleIds.techResource" />
                          Address Line 4:<input matInput class="em-c-input em-js-input" type="text"
                            placeholder="Top Address Line 4" formControlName="fromAddress4"
                            [readonly]="roleId === roleIds.techResource" />
                        </div>
                      </div>

                    </div>
                    <br><br>
                    <span class="em-c-field__label">Report date: {{ frontPageForm.get('reportDate')?.value |
                      date:'MM/dd/yyyy' }}</span>

                    <div class="reportTo">
                      <!-- Report To Prefix-->
                      <div id="reportToPrefix-field"
                        class="em-c-field em-c-field--small em-u-max-width-15  min-height-62">
                        <label for="reportToPrefix" class="em-c-field__label">Report To Prefix</label>
                        <div class="em-c-field__body">
                          <select class="em-c-select em-u-max-width-10" formControlName="reportToPrefix"
                            id="reportToPrefix" name="reportToPrefix">
                            <option value="" disabled>Select</option>
                            <option value="Mr">Mr</option>
                            <option value="Mrs">Mrs</option>
                            <option value="Ms">Ms</option>
                          </select>
                        </div>
                      </div>

                      <!-- Report To -->
                      <div id="reportTo-field" class="em-c-field em-c-field--small em-u-max-width-15 min-height-62">
                        <label for="reportTo" class="em-c-field__label">Report To</label>
                        <div class="em-c-field__body">
                          <input matInput class="em-c-input em-js-input em-u-max-width-15" type="text"
                            formControlName="reportTo" id="reportTo" [readonly]="roleId === roleIds.techResource" />
                        </div>
                      </div>
                    </div>
                    <span class="em-c-field__label">Report to address: </span>
                    <div class="addressRow">
                      Address Line 1: <input matInput class="em-c-input em-js-input" type="text"
                        placeholder="Report to Address Line 1" formControlName="toAddress1"
                        [readonly]="roleId === roleIds.techResource" />
                      Address Line 2:<input matInput class="em-c-input em-js-input" type="text"
                        placeholder="Report to Address Line 2" formControlName="toAddress2"
                        [readonly]="roleId === roleIds.techResource" />
                    </div>
                    <div class="addressRow">
                      Address Line 3:<input matInput class="em-c-input em-js-input" type="text"
                        placeholder="Report to Address Line 3" formControlName="toAddress3"
                        [readonly]="roleId === roleIds.techResource" />
                      Address Line 4:<input matInput class="em-c-input em-js-input" type="text"
                        placeholder="Report to Address Line 4" formControlName="toAddress4"
                        [readonly]="roleId === roleIds.techResource" />
                    </div>
                    <br><br>
                    <p>Dear {{ coverLetterForm.get('reportTo')?.value }},</p>

                    <p class="pre-line-text">
                      @if(ShowSeparatorForm()){
                      {{reportConstants.separatorCoverLetterP1}} {{this.wellName}} {{this.reportSampleType}}
                      {{reportConstants.separatorCoverLetterP2}}
                      }
                      @else if(ShowDSTForm() || ShowMDTForm()) {
                      @if(ShowDSTForm()){
                      {{reportConstants.dstCoverLetterP1}} {{this.wellName}} {{this.reportSampleType}}
                      {{reportConstants.dstCoverLetterP2}}
                      }
                      @else if(ShowMDTForm()){
                      {{reportConstants.mdtCoverLetterP1}} {{this.wellName}} {{this.reportSampleType}}
                      {{reportConstants.mdtCoverLetterP2}}
                      }
                      <input matInput class="em-c-input em-js-input" type="text"
                        placeholder="Production/Perforation Interval" formControlName="productionIntervalCover"
                        [readonly]="roleId === roleIds.techResource" />
                      @if(ShowDSTForm()){
                      {{reportConstants.dstCoverLetterP3}} {{reportConstants.dstCoverLetterP4}}
                      }@else if(ShowMDTForm()){
                      {{reportConstants.mdtCoverLetterP3}}
                      }}
                    </p>

                    <div class="commentsQuestions">
                      <textarea name="comments" id="comments" formControlName="comments"
                        [readonly]="roleId === roleIds.techResource"></textarea>
                    </div>
                    <br>
                    <div class="regardsRow">
                      <div class="regardsRow2">
                        <p class="pre-line-text">Regards,</p>
                        <input matInput class="em-c-input em-js-input" type="text" placeholder=""
                          formControlName="regards" [readonly]="roleId === roleIds.techResource" />
                      </div>
                    </div>
                    <br>
                    <div class="byRow">
                      <p class="by-label">By</p>
                      <input
                        matInput
                        class="em-c-input em-js-input"
                        type="text"
                        placeholder="By"
                        formControlName="by"
                        [readonly]="roleId === roleIds.techResource" />

                      <button
                        #byInfoButton
                        type="button"
                        class="info-button"
                        (mouseover)="ShowByInfo()"
                        (focus)="ShowByInfo()"
                        (mouseout)="HideByInfo()"
                        (blur)="HideByInfo()">

                        <svg class="em-c-icon em-c-icon--small em-c-btn__icon">
                          <use
                            xmlns:xlink="http://www.w3.org/1999/xlink"
                            xlink:href="images/16/em-icons.svg#info">
                          </use>
                        </svg>

                      </button>
                    </div>
                    <div class="row">
                      <div class="byRow">
                        <p>Attachment </p><input matInput class="em-c-input em-js-input" type="text"
                          placeholder="Please paste the attachment link here" formControlName="attachment"
                          [readonly]="roleId === roleIds.techResource" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <hr />

        <div class="button-div">
          <div class="em-c-btn-group">
            @if (ShowReportDetailsSave()) {
            <button class="em-c-btn em-c-btn--primary em-c-btn--small"
              [class.readonly-select]="roleId === roleIds.techResource"
              (click)="SaveFinalReportDetailsData('save')">Save</button>
            }
            @if (ShowReportDetailsUpdate()) {
            <button class="em-c-btn em-c-btn--primary em-c-btn--small"
              [class.readonly-select]="roleId === roleIds.techResource"
              (click)="SaveFinalReportDetailsData('update')">Update</button>
            }
            <button class="em-c-btn em-c-btn--small em-js-modal-dismiss" (click)="OnCancel()">Cancel</button>
          </div>
        </div>
      </mat-tab>

      <mat-tab label="Analyses Methods">
        <div>
          <form [formGroup]="analysesMethodsForm">
            <div class="form-row">
              <div class="analysesMethodsForm-data">
                <div class="em-c-card">
                  <div class="em-c-media-block__body" [formGroup]="analysesMethodsForm">
                    <div class="row">
                      <h5>Summary of Analyses Methods</h5>
                      <br>
                      <!-- separator -->
                      <div class="row">
                        @if(ShowSeparatorForm()){
                        <div class="contentHeader">
                          <span class="em-c-field__label"><b>Fluid Recombination</b></span>
                          <div class="contentBody">
                            <p>{{analysesMethodsConstants.fluidRecombination}} <input matInput
                                class="em-c-input em-js-input em-u-max-width-15" type="text" placeholder=""
                                formControlName="fluidRecombination" [readonly]="roleId === roleIds.techResource" />.
                            </p>
                          </div>
                        </div>}
                        @else if(ShowMDTForm() || ShowDSTForm()){
                        <div class="contentHeader">
                          <span class="em-c-field__label"><b>Sample Restoration</b></span>
                          <div class="contentBody">
                            <p>{{analysesMethodsConstants.sampleRestoration1}} <input matInput
                                class="em-c-input em-js-input em-u-max-width-15" type="text" placeholder=""
                                formControlName="sampleRestorationTemp" [readonly]="roleId === roleIds.techResource" />
                              {{analysesMethodsConstants.sampleRestoration2}} <input matInput
                                class="em-c-input em-js-input em-u-max-width-15" type="text" placeholder=""
                                formControlName="sampleRestorationPressure"
                                [readonly]="roleId === roleIds.techResource" />{{analysesMethodsConstants.sampleRestoration3}}
                              <input matInput class="em-c-input em-js-input em-u-max-width-15" type="text"
                                placeholder="" formControlName="sampleRestorationDays"
                                [readonly]="roleId === roleIds.techResource" />
                              {{analysesMethodsConstants.sampleRestoration4}}
                            </p>
                          </div>
                        </div>
                        }
                        <div class="row">
                          <div class="contentHeader">
                            <span class="em-c-field__label"><b>Single Stage Flash</b></span>
                            <div class="contentBody">
                              <p>{{analysesMethodsConstants.singleStageFlash1}}
                                @if(ShowMDTForm() || ShowDSTForm()){
                                {{analysesMethodsConstants.singleStageFlash2}}
                                }
                              </p>
                            </div>
                          </div>
                        </div>
                        @if(experimentNames.includes(reportConstants.experimentNameBCA)){
                        <div class="row">
                          <div class="contentHeader">
                            <span class="em-c-field__label"><b>Compositional Analysis</b></span>
                            <div class="contentBody">
                              <p>{{analysesMethodsConstants.compositionalAnalysis1}} <input matInput
                                  class="em-c-input em-js-input em-u-max-width-15" type="text" placeholder=""
                                  formControlName="compositionalAnalysis"
                                  [readonly]="roleId === roleIds.techResource" />.
                                {{analysesMethodsConstants.compositionalAnalysis2}}</p>
                            </div>
                          </div>
                        </div>
                        }
                        @if(experimentNames.includes(reportConstants.experimentNameCCE)){
                        <div class="row">
                          <div class="contentHeader">
                            <span class="em-c-field__label"><b>Constant Composition Expansion</b></span>
                            <div class="contentBody">
                              <p>{{analysesMethodsConstants.CCE1}} <input matInput
                                  class="em-c-input em-js-input em-u-max-width-15" type="text" placeholder=""
                                  formControlName="ccePressure" [readonly]="roleId === roleIds.techResource" />
                                {{analysesMethodsConstants.CCE2}}
                                <input matInput class="em-c-input em-js-input em-u-max-width-15" type="text"
                                  placeholder="" formControlName="cceIsothermic"
                                  [readonly]="roleId === roleIds.techResource" />
                                {{analysesMethodsConstants.CCE3}}
                              </p>
                            </div>
                          </div>
                        </div>
                        }
                        @if(ShowSeparatorForm() && experimentNames.includes(reportConstants.experimentNameSwelling)){
                        <div class="row">
                          <div class="contentHeader">
                            <span class="em-c-field__label"><b>Swelling Tests</b></span>
                            <div class="contentBody">
                              <p>{{analysesMethodsConstants.swelling1}} <input matInput
                                  class="em-c-input em-js-input em-u-max-width-15" type="text" placeholder=""
                                  formControlName="swellingTest" [readonly]="roleId === roleIds.techResource" />
                                {{analysesMethodsConstants.swelling2}}
                              </p>
                            </div>
                          </div>
                        </div>
                        }
                        <div class="row">
                          <div class="contentHeader">
                            <span class="em-c-field__label"><b>Separator Tests</b></span>
                            <div class="contentBody">
                              <p>{{analysesMethodsConstants.separatorTest}}</p>
                            </div>
                          </div>
                        </div>
                        @if(ShowDSTForm() ){
                        <div class="row">
                          <div class="contentHeader">
                            <span class="em-c-field__label"><b>Constant Volume Depletion</b></span>
                            <div class="contentBody">
                              <p>{{analysesMethodsConstants.CVD}}</p>
                            </div>
                          </div>
                        </div>
                        }
                        @if((ShowMDTForm() || ShowDSTForm()) && experimentNames.includes(reportConstants.experimentNameSwelling)){
                        <div class="row">
                          <div class="contentHeader">
                            <span class="em-c-field__label"><b>Swelling Tests</b></span>
                            <div class="contentBody">
                              <p>{{analysesMethodsConstants.swelling1}} <input matInput
                                  class="em-c-input em-js-input em-u-max-width-15" type="text" placeholder=""
                                  formControlName="swellingTest" [readonly]="roleId === roleIds.techResource" />
                                {{analysesMethodsConstants.swelling2}}
                              </p>
                            </div>
                          </div>
                        </div>
                        }
                        <div class="row">
                          <div class="contentHeader">
                            <span class="em-c-field__label"><b>Cambridge EMV Viscosity Measurement</b></span>
                            <div class="contentBody">
                              <p>@if(ShowSeparatorForm()){
                                {{analysesMethodsConstants.cambridgeEMVSeparator}} }
                                @else if(ShowMDTForm() || ShowDSTForm()){
                                {{analysesMethodsConstants.cambridgeEMVMDTDST}}
                                } <input matInput class="em-c-input em-js-input em-u-max-width-15" type="text"
                                  placeholder="" formControlName="cambridgeEMV"
                                  [readonly]="roleId === roleIds.techResource" />
                                {{analysesMethodsConstants.cambridgeEMV2}}
                              </p>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="contentHeader">
                            <span class="em-c-field__label"><b>Density Measurement</b></span>
                            <div class="contentBody">
                              <p>{{analysesMethodsConstants.density}}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <hr />

        <div class="button-div">
          <div class="em-c-btn-group">
            @if (ShowAnalyseMethodsSave()) {
            <button class="em-c-btn em-c-btn--primary em-c-btn--small"
              [class.readonly-select]="roleId === roleIds.techResource"
              (click)="SaveAnalysesMethods('save')">Save</button>
            }
            @if (ShowAnalyseMethodsUpdate()) {
            <button class="em-c-btn em-c-btn--primary em-c-btn--small"
              [class.readonly-select]="roleId === roleIds.techResource"
              (click)="SaveAnalysesMethods('update')">Update</button>
            }
            <button class="em-c-btn em-c-btn--small em-js-modal-dismiss" (click)="OnCancel()">Cancel</button>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<ng-template #byInfoTemplate>
  <div class="tooltip-comments">
    <div class="comments">
      {{enterInitialsCommaSeparatedMessage}}
    </div>
  </div>
</ng-template>

<ng-template #cancelDialog let-dialogRef="dialogRef">
  <div class="em-c-modal" role="alertdialog" aria-modal="true" aria-labelledby="modalTitle"
    aria-describedby="modalDescription">
    <section class="em-c-modal__window">
      <div class="em-c-modal__header mb-0" tabindex="0">
        <div>
          <div class="em-c-modal__title" id="modalTitle">
            Cancel Final Sample Inputs
          </div>
        </div>
        <button [mat-dialog-close]="false" class="em-c-btn em-c-btn--bare em-c-modal__close-btn" title="Close modal"
          aria-label="Button name">
          <div class="em-c-btn__inner">
            <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#x-filled"></use>
            </svg>
          </div>
        </button>
      </div>
      <div class="em-c-modal__body font-12" id="modalDescription">
        Sample Inputs data will be lost. Are you sure you want to cancel?
      </div>
      <div class="em-c-modal__footer mt-10">
        <div class="em-c-btn-group">
          <button (click)="dialogRef.close(true)" class="em-c-btn em-c-btn--primary modal-btn">
            <span class="em-c-btn__text">Yes</span>
          </button>
          <button (click)="dialogRef.close(false)" class="em-c-btn em-js-modal-dismiss modal-btn">
            <span class="em-c-btn__text">No</span>
          </button>
        </div>
      </div>
    </section>
    <div class="em-c-modal__overlay em-is-closed"></div>
  </div>
</ng-template>

<ng-template #checkboxWarningDialog let-dialogRef="dialogRef">
  <div class="em-c-modal" role="alertdialog" aria-modal="true" aria-labelledby="modalTitle"
    aria-describedby="modalDescription">
    <section class="em-c-modal__window">
      <div class="em-c-modal__header mb-0" tabindex="0">
        <div>
          <div class="em-c-modal__title" id="modalTitle">
            Sampling Information
          </div>
        </div>
        <button [mat-dialog-close]="false" class="em-c-btn em-c-btn--bare em-c-modal__close-btn" title="Close modal"
          aria-label="Button name">
          <div class="em-c-btn__inner">
            <svg class="em-c-icon em-c-icon--small  em-c-btn__icon">
              <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="images/16/em-icons.svg#x-filled"></use>
            </svg>
          </div>
        </button>
      </div>
      <div class="em-c-modal__body font-12" id="modalDescription">
        You can select maximum two records.
      </div>
      <div class="em-c-modal__footer mt-10">
        <div class="em-c-btn-group">
          <button (click)="dialogRef.close(false)" class="em-c-btn em-js-modal-dismiss modal-btn">
            <span class="em-c-btn__text">Cancel</span>
          </button>
        </div>
      </div>
    </section>
    <div class="em-c-modal__overlay em-is-closed"></div>
  </div>
</ng-template>

<!-- Lab Crew delete confirmation dialog -->
<ng-template #deleteCrewDialog let-dialogRef="dialogRef">
  <div class="em-c-modal" role="alertdialog" aria-modal="true" aria-labelledby="crewModalTitle"
    aria-describedby="crewModalDescription">
    <section class="em-c-modal__window">
      <div class="em-c-modal__header" tabindex="0">
        <div>
          <div class="em-c-modal__title" id="crewModalTitle">
            Delete Row
          </div>
        </div>
        <button [mat-dialog-close]="false" class="em-c-btn em-c-btn--bare em-c-modal__close-btn" title="Close modal"
          aria-label="Close">
          <div class="em-c-btn__inner">
            <svg class="em-c-icon em-c-icon--small em-c-btn__icon">
              <use xlink:href="images/16/em-icons.svg#x-filled"></use>
            </svg>
          </div>
        </button>
      </div>

      <div class="em-c-modal__body" id="crewModalDescription">
        Are you sure you want to delete this Lab Crew row (index {{ pendingCrewDeleteIndex + 1 }})?
      </div>

      <div class="em-c-modal__footer mt-10">
        <div class="em-c-btn-group">
          <button (click)="dialogRef.close(true)" class="em-c-btn em-c-btn--primary modal-btn">
            <span class="em-c-btn__text">Yes</span>
          </button>
          <button (click)="dialogRef.close(false)" class="em-c-btn em-js-modal-dismiss modal-btn">
            <span class="em-c-btn__text">No</span>
          </button>
        </div>
      </div>
    </section>
    <div class="em-c-modal__overlay em-is-closed"></div>
  </div>
</ng-template>